// extracted by mini-css-extract-plugin
export default {"override":"StyleOverride_override__cmkYE"};